module.exports = __webpack_public_path__ + "img/HK@3x.a9b001ed.png";